var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:(_vm.styles)},[_c('span',{style:(_vm.initialStyles)},[_vm._v(_vm._s(_vm._f("truncate")(_vm.initials,2, '')))]),_c('div',{staticClass:"photo",style:(_vm.photoStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }